import React from "react";
import {Auth} from "@aws-amplify/auth";
import TextField from "../../common/TextField";
import ResultMessageText from "../../common/ResultMessageText";
import {withRouter} from "react-router-dom";
import {ForgotPassword} from 'aws-amplify-react';
import LoginContainer from './components/LoginContainer';
import styled from "styled-components";
import ActionButton from "../../common/ActionButton";

const ChangeFormLink = styled.a`
  margin-top: 2em;
  margin-right: 2em;
  color: black;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;

  :hover {
    text-decoration: underline;
  }
`;

class ForgotPasswordPage extends ForgotPassword {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
            verificationCodeSent: false,
            verificationCode: '',
            newPassword: '',
            confirmPassword: '',
            errorMessage: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitVerificationCode = this.handleSubmitVerificationCode.bind(this);
    }

    handleSubmitVerificationCode(event) {
        event.preventDefault();
        this.sendVerificationCode();
    }

    sendVerificationCode = async () => {
        const {email} = this.state;
        try {
            await Auth.forgotPassword(email);
            this.setStateCodeSent();
        } catch (err) {
            this.setState({
                errorMessage: err.message
            });
        }
    };

    setStateCodeSent = () => {
        this.setState({
            verificationCodeSent: true,
            errorMessage: '',
        });
    }

    handleSubmit(event) {
        const {newPassword, confirmPassword} = this.state;
        event.preventDefault();

        if (newPassword === confirmPassword) {
            this.forgotPasswordSubmit();
        } else {
            this.setState({
                errorMessage: "New Password and Confirm Password is not matching."
            });
        }
    }

    forgotPasswordSubmit = async () => {
        const {email, verificationCode, newPassword} = this.state;
        try {
            await Auth.forgotPasswordSubmit(email, verificationCode, newPassword);
            this.props.onStateChange('signIn');
            this.setState({
                verificationCodeSent: false,
                errorMessage: ''
            });
        } catch (err) {
            this.setState({
                errorMessage: err.message
            });
        }
    };

    returnToLogin = () => {
        this.setState({
            verificationCodeSent: false,
            errorMessage: ''
        });
        this.props.onStateChange('signIn');
    };


    onChange = event => {
        let target = event.target;
        this.setState({
            [target.id]: target.value
        });
    };

    showComponent(theme) {
        const {email, verificationCode, newPassword, confirmPassword, errorMessage, verificationCodeSent} = this.state;

        if (!verificationCodeSent) {
            return (
                <LoginContainer>
                    <form onSubmit={this.handleSubmitVerificationCode}>
                        <TextField
                            className="mt-4"
                            id="email"
                            label="Email"
                            value={email}
                            valueChanged={this.onChange}
                            legacyMode={true}>
                        </TextField>
                        <ActionButton
                            className="mt-4"
                            type="submit"
                            text="Reset Password"/>
                    </form>
                    <ResultMessageText text={errorMessage} success={false}/>
                    <ChangeFormLink onClick={this.returnToLogin}>
                        Return to Login page
                    </ChangeFormLink>
                    <ChangeFormLink onClick={this.setStateCodeSent}>
                        Input verification code
                    </ChangeFormLink>
                </LoginContainer>
            );
        } else {
            return (
                <LoginContainer>
                    <form onSubmit={this.handleSubmit}>
                        <TextField
                            className="mt-4"
                            id="verificationCode"
                            label="Verification Code"
                            value={verificationCode}
                            valueChanged={this.onChange}
                            legacyMode={true}>
                        </TextField>
                        <TextField
                            className="mt-4"
                            id="newPassword"
                            label="New Password"
                            value={newPassword}
                            valueChanged={this.onChange}
                            type="password"
                            legacyMode={true}>
                        </TextField>
                        <TextField
                            className="mt-4"
                            id="confirmPassword"
                            label="Confirm Password"
                            value={confirmPassword}
                            valueChanged={this.onChange}
                            type="password"
                            legacyMode={true}>
                        </TextField>
                        <ActionButton
                            className="mt-4"
                            type="submit"
                            text="Change Password"/>
                    </form>
                    <ResultMessageText text={errorMessage} success={false}/>
                    <ChangeFormLink onClick={this.returnToLogin}>Return to Login
                        page</ChangeFormLink>
                </LoginContainer>
            );
        }
    }
}

export default withRouter(ForgotPasswordPage);
